<div class="controls-container">
    <p class="controls-title" i18n>Show only {{itemLabels.plural}} where:</p>

    <p *ngIf="easForm?.controls.length === 0" i18n>You haven't applied any filters yet. Add a filter below.</p>

    <ng-container *ngIf="filterForms">
        <ng-container *ngFor="let easForm of filterForms; let last=last">
            <form *ngIf="easForm" [formGroup]="easForm.form.control" class="form-group">
                <div *ngFor="let control of easForm.form.controls" class="form-input">
                    <eas-easform-control-single [easControl]="control"></eas-easform-control-single>
                </div>
                <button *ngIf="!last" mat-stroked-button color="warn" type="button" (click)="removeFilter(easForm)">
                    <mat-icon>remove</mat-icon> <span i18n>Remove Filter</span>
                </button>
            </form>
        </ng-container>
    </ng-container>

    <hr />

    <div class="controls-footer-buttons">
      <!-- <button mat-flat-button color="accent" (click)="apply()">
          <mat-icon>check</mat-icon> Apply
      </button> -->

      <button mat-flat-button color="warn" (click)="clearFilters()">
          <mat-icon>delete</mat-icon> <span i18n>Remove All Filters</span>
      </button>
    </div>

</div>
